import { Mail, Phone, Clock, CheckCircle2 } from "lucide-react";
import { IMAGES } from "@/data/content";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import ContactForm from "@/components/ContactForm";
import CalendlyWidget from "@/components/CalendlyWidget";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <PageHero
        eyebrow="Book a Consultation"
        title="Ready to Map Your International Move?"
        subtitle="Select a time below to secure your 1:1 strategy consultation — or send us a message and we'll reach out."
        image={IMAGES.meeting}
      />

      <section className="py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-[1.1fr_0.9fr] gap-16 items-start">
          {/* LEFT: form + info */}
          <Reveal>
            <span className="text-gl-gold uppercase tracking-[0.3em] text-xs mb-4 block">
              Pre-Consultation Questionnaire
            </span>
            <h2 className="font-serif-display text-3xl md:text-4xl font-light text-gl-text mb-8">
              Tell us where you want to go.
            </h2>
            <ContactForm />

            <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-6 border-t border-gl-gold/15 pt-10">
              {[
                { Icon: Mail, label: "Email", value: "realty@goodlivingllc.info" },
                { Icon: Phone, label: "Phone", value: "(470) 896-2046" },
                { Icon: Clock, label: "Hours", value: "Mon–Fri · 9am–6pm" },
                { Icon: CheckCircle2, label: "Response", value: "Within 24 hours" },
              ].map(({ Icon, label, value }) => (
                <div key={label} className="flex items-start gap-3">
                  <span className="w-10 h-10 flex-shrink-0 border border-gl-gold/30 flex items-center justify-center text-gl-gold">
                    <Icon size={18} />
                  </span>
                  <div>
                    <div className="text-xs uppercase tracking-[0.2em] text-gl-text2">{label}</div>
                    <div className="text-gl-text font-light">{value}</div>
                  </div>
                </div>
              ))}
            </div>
          </Reveal>

          {/* RIGHT: Calendly */}
          <Reveal delay={0.15} className="lg:sticky lg:top-28 lg:self-start">
            <span className="text-gl-gold uppercase tracking-[0.3em] text-xs mb-4 block">
              Book Instantly
            </span>
            <h2 className="font-serif-display text-3xl md:text-4xl font-light text-gl-text mb-8">
              Pick a time that works for you.
            </h2>
            <CalendlyWidget />
          </Reveal>
        </div>
      </section>
    </div>
  );
}
